import React, { Component } from 'react'
import Arrow from './Arrow/'
import styled from 'styled-components'
import { visible, SCREEN_SIZE } from '../../lib/Media'

const StyledCarouselWrapper = styled.div`
  position: relative;

  ${SCREEN_SIZE.Only.Mobile} {
    width: 100%;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    width: 100%;
  }
`

const ArrowContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;

  ${({ direction }) =>
    direction === 'left' ? 'left: -1.25rem;' : 'right: -1.25rem;'}

  ${visible(SCREEN_SIZE.From.Desktop)}
  ${SCREEN_SIZE.From.Hd} {
    display: ${props => (props.hideArrow ? 'none' : 'inherit')};
  }
`
const CarouselContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  position: relative;
  scrollbar-width: none; /*To hide scrollbar in firefox */
  -webkit-overflow-scrolling: touch;

  ${SCREEN_SIZE.From.Desktop} {
    overflow-x: hidden;
  }

  &--left {
    left: -0.94rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

class Carousel extends Component {
  constructor(props) {
    super(props)
    this.carouselData = this.props.children
    this.state = {
      currentImageIndex: 0,
      translateValue: 0,
      showRightArrow: true,
      isOverFlow: false,
    }
    this.getChildrenWidth = this.getChildrenWidth.bind(this)
    this.slideWidth = this.slideWidth.bind(this)
    this.nextSlide = this.nextSlide.bind(this)
    this.scrollWidth = this.scrollWidth.bind(this)
  }

  nextSlide() {
    if (
      this.getChildrenWidth() -
        (-this.state.translateValue + this.slideWidth()) <
      this.slideWidth()
    ) {
      if (
        this.props.hasMore &&
        this.props.infiniteScrolling !== false &&
        this.getChildrenWidth() + this.state.translateValue ===
          this.slideWidth()
      ) {
        this.props.loadChildren()
      } else {
        if (this.getChildrenWidth() > this.slideWidth()) {
          this.setState(prevState => ({
            translateValue:
              prevState.translateValue +
              -(
                this.getChildrenWidth() -
                (-this.state.translateValue + this.slideWidth())
              ),
            showRightArrow: false,
          }))
        }
      }
    } else {
      this.setState(prevState => ({
        translateValue: prevState.translateValue + -this.scrollWidth(),
      }))
    }
  }

  previousSlide() {
    if (this.state.translateValue - -this.slideWidth() >= 0) {
      this.setState({
        translateValue: 0,
        showRightArrow: true,
      })
    } else {
      this.setState(prevState => ({
        translateValue: prevState.translateValue - -this.scrollWidth(),
        showRightArrow: true,
      }))
    }
  }

  getElementFromNode = () => this.nodeRef?.querySelector('.elements-div') || {}

  slideWidth = () => this.getElementFromNode().clientWidth

  getChildrenWidth() {
    const children = this.getElementFromNode().children
    let totalWidth = 0
    for (let i = 0; i < children.length; i++) {
      totalWidth += children[i].offsetWidth
      const style =
        children[i].currentStyle || window.getComputedStyle(children[i])
      const margin =
        parseFloat(style.marginLeft) + parseFloat(style.marginRight)
      totalWidth += margin
    }
    return totalWidth
  }

  scrollWidth() {
    let parent
    let children
    let viewPortWidth
    let count = 0
    if (this.nodeRef) {
      parent = this.nodeRef.querySelector('.viewport')
      viewPortWidth = parent.clientWidth
      children = this.getElementFromNode().children

      // Find the number of children which are inside viewPort
      for (let i = 0; i < children.length; i++) {
        const childRect = children[i].getBoundingClientRect()
        const parentRect = parent.getBoundingClientRect()
        if (
          childRect.left >= parentRect.left &&
          childRect.right <= parentRect.right
        ) {
          count++
        } else if (count) {
          break
        }
      }
    }
    return count && children ? count * children[0].offsetWidth : viewPortWidth
  }

  componentDidUpdate(prevProps) {
    const isOverFlow =
      this.nodeRef && this.getChildrenWidth() > this.slideWidth()
    const { selectedIndex } = this.props
    if (isOverFlow !== (this.state && this.state.isOverFlow)) {
      this.setState({ isOverFlow })
    }
    if (
      prevProps.children &&
      prevProps.children.length &&
      prevProps.children.length !== this.props.children.length
    ) {
      this.setState({ translateValue: 0, showRightArrow: true })
    }
    if (
      this.props.resetPosition &&
      prevProps.resetPosition !== this.props.resetPosition
    ) {
      this.setState(
        { translateValue: 0, showRightArrow: true },
        this.props.resetCarouselPosition
      )
    }
    if (selectedIndex && prevProps.selectedIndex !== selectedIndex) {
      this.setState({ currentImageIndex: selectedIndex })
    }
  }

  componentDidMount() {
    this.setState({
      isOverFlow: this.nodeRef && this.getChildrenWidth() > this.slideWidth(),
    })

    /* Setting the initial scroll for date. This will enable us to capture
    user selected timeslot and show the same in timeslot popup */
    const { selectedIndex, children } = this.props
    if (selectedIndex > 2 && this.state.isOverFlow) {
      const idx = selectedIndex - 1
      const totalWidth = this.getChildrenWidth()
      const childCount = children.length
      const oneElementWidth = totalWidth / childCount
      const calculatedScroll = -(idx * oneElementWidth)
      this.setState({
        translateValue: calculatedScroll,
        isOverFlow: true,
      })
    }
  }

  render() {
    const { translateValue, isOverFlow } = this.state
    return (
      <StyledCarouselWrapper
        className="horizontal-carousel"
        ref={node => {
          this.nodeRef = node
        }}
      >
        {isOverFlow && translateValue !== 0 && (
          <ArrowContainer direction="left" hideArrow={this.props.hideArrow}>
            <Arrow
              direction="left"
              clickFunction={() => this.previousSlide()}
            />
          </ArrowContainer>
        )}
        <CarouselContainer className="viewport">
          <ul
            className={
              'elements-div' + (!isOverFlow ? ' content-not-overflow' : '')
            }
            style={{
              position: 'relative',
              left: `${translateValue}px`,
              transition: 'left ease-out 0.45s',
            }}
            data-testid="carousel"
          >
            {this.props.children}
          </ul>
        </CarouselContainer>
        {isOverFlow && this.state.showRightArrow && (
          <ArrowContainer direction="right" hideArrow={this.props.hideArrow}>
            <Arrow direction="right" clickFunction={() => this.nextSlide()} />
          </ArrowContainer>
        )}
      </StyledCarouselWrapper>
    )
  }
}

export default Carousel
